var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-fine-uploader-file-input"},[_c('label',[_vm._t("default",[_vm._v("Upload File")]),_vm._v(" "),_c('input',{attrs:{"type":"file","multiple":_vm.multiple,"accept":_vm.accept,"required":_vm.required},on:{"change":_vm._onFilesSelected}})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-154244b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-fineuploader/file-input.vue
// module id = w5Lk
// module chunks = 0